export const DEVICE_SET = 'devicePermission';
export const HANDLER_SET = 'setHandlerMode';
export const LABEL_SET = 'changeLabel';
export const SCREEN_LAYOUT_SET = 'changeScreenMode';
export const COUNT_SET = 'gridCountSet';
export const CHAT_FILE_LOCK = 'chatFileLock';
export const NOTIFICATION_SET = 'notificationSet';

export const SETTING_LIST = [DEVICE_SET, CHAT_FILE_LOCK, HANDLER_SET, SCREEN_LAYOUT_SET, NOTIFICATION_SET, LABEL_SET];
